import React from 'react';

const Question = ({ question, formData, handleChange, consent }) => {
  const { QuestionNumber, QuestionText, QuestionType, QuestionChoices, RemarksNameField, ConsentStatus } = question;

  // Check if the question should be displayed based on consent status
  if (ConsentStatus === "Yes" && !consent) {
    return null;
  }

  return (
    <div className="form-group">
      <label>{QuestionText}</label>
      {QuestionType === 'MultipleChoice' && (
        <div className="radio-group">
          {Object.entries(QuestionChoices).map(([key, value]) => (
            <label key={key}>
              <input
                type="radio"
                name={`form_question_${QuestionNumber}`}
                value={value}
                checked={formData[`form_question_${QuestionNumber}`] === value}
                onChange={handleChange}
              />
              {value}
            </label>
          ))}
        </div>
      )}
      {QuestionType === 'OpenEnd' && (
        <div className="form-group">
          <input
            type="text"
            name={`form_question_${QuestionNumber}`}
            value={formData[`form_question_${QuestionNumber}`] || ''}
            onChange={handleChange}
            className="form-input"
            placeholder= "Bitte keine personenbezogenen Daten eingeben"
          />
        </div>
      )}
      {formData[`form_question_${QuestionNumber}`] === 'Nein' && consent && RemarksNameField && (
        <div className="form-group">
          <label>{RemarksNameField}</label>
          <input
            type="text"
            name={`form_remarks_${QuestionNumber}`}
            value={formData[`form_remarks_${QuestionNumber}`] || ''}
            onChange={handleChange}
            className="form-input"
          />
        </div>
      )}
    </div>
  );
};

export default Question;
